import type { MenuItemControlProps } from '@1js/acui-ribbon-like/lib/UISurfaces/controls/Menu';
import type { ClientItemId } from 'owa-client-ids';
import { constructKeytip, getKeytipString } from 'owa-command-ribbon';
import { ControlInfo, getControlInfo } from 'owa-mail-ribbon-utils';
import { MailRibbonControlId, MailRibbonTabId } from 'owa-ribbon-ids';
import {
    onBlockClicked,
    onJunkNotJunkClicked,
    onMarkAsPhishingClicked,
} from '../../util/commandActions';
import { createMailAppButton } from '../../util/createMailRibbonButton';
import { getReadRibbonId } from '../../util/getReadRibbonId';
import { isFeatureEnabled } from 'owa-feature-flags';

// This should be replaced with the getJunkSectionsBreakoutPhishingFlightOn function
// when flight 'tri-changeReportActionsPlacement-v1' is graduated
export default function getJunkSections(
    keytipTabId: MailRibbonTabId | undefined,
    iconColor?: string,
    itemId?: ClientItemId,
    targetWindow?: Window
): MenuItemControlProps[] {
    const controls: MenuItemControlProps[] = [];

    let controlId: MailRibbonControlId = MailRibbonControlId.JunkNotJunk;
    let controlInfo: ControlInfo = getControlInfo(controlId);

    controls.push(
        createMailAppButton(
            getReadRibbonId(controlId, itemId),
            controlInfo.text,
            controlInfo.tooltip,
            itemId !== undefined /*isPopout*/,
            onJunkNotJunkClicked(itemId, targetWindow),
            constructKeytip(
                keytipTabId
                    ? [
                          getKeytipString(keytipTabId),
                          getKeytipString(MailRibbonControlId.JunkFlyout),
                      ]
                    : [getKeytipString(MailRibbonControlId.JunkFlyout)],
                getKeytipString(controlId)
            ),
            controlInfo.iconName,
            iconColor
        )
    );

    if (!isFeatureEnabled('tri-changeReportActionsPlacement-v1')) {
        controlId = MailRibbonControlId.Phishing;
        controlInfo = getControlInfo(controlId);

        controls.push(
            createMailAppButton(
                getReadRibbonId(controlId, itemId),
                controlInfo.text,
                controlInfo.tooltip,
                itemId !== undefined /*isPopout*/,
                onMarkAsPhishingClicked(itemId, targetWindow),
                constructKeytip(
                    keytipTabId
                        ? [
                              getKeytipString(keytipTabId),
                              getKeytipString(MailRibbonControlId.JunkFlyout),
                          ]
                        : [getKeytipString(MailRibbonControlId.JunkFlyout)],
                    getKeytipString(controlId)
                ),
                controlInfo.iconName,
                iconColor
            )
        );
    }

    controlId = MailRibbonControlId.Block;
    controlInfo = getControlInfo(controlId);

    controls.push(
        createMailAppButton(
            getReadRibbonId(controlId, itemId),
            controlInfo.text,
            controlInfo.tooltip,
            itemId !== undefined /*isPopout*/,
            onBlockClicked(itemId, targetWindow),
            constructKeytip(
                keytipTabId
                    ? [
                          getKeytipString(keytipTabId),
                          getKeytipString(MailRibbonControlId.JunkFlyout),
                      ]
                    : [getKeytipString(MailRibbonControlId.JunkFlyout)],
                getKeytipString(MailRibbonControlId.Block)
            ),
            controlInfo.iconName,
            iconColor
        )
    );

    return controls;
}
